import { useCallback, useEffect, useRef } from "react";
import { getAssetUrls } from "../../services/emailtemplate.service";

// Imagens dos Templates de Email: o valor guardado usa mexx-email-asset://{id} (a URL real do arquivo expira;
// o Worker resolve no envio). Pra exibir num editor, troca marcador → URL temporaria (POST
// emailtemplates/asset-urls) e, na saida, URL → marcador. Assim o snapshot nunca leva URL temporaria.
//
// Uso com o RichTextEditor: toDisplay/fromDisplay nos ganchos homonimos; onResolved(→ ref.refreshDisplay())
// reexibe quando as URLs chegam.

const ASSET_MARKER_REGEX = /mexx-email-asset:\/\/([1-9][0-9]*)/gi;

const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const extractAssetIds = (html) => {
  const ids = new Set();
  let match;
  ASSET_MARKER_REGEX.lastIndex = 0;
  while ((match = ASSET_MARKER_REGEX.exec(html || "")) !== null) ids.add(Number(match[1]));
  return Array.from(ids);
};

export default function useEmailAssetDisplay(html, onResolved) {
  const urlsRef = useRef({}); // id → URL temporaria
  const requestedRef = useRef(new Set());
  const onResolvedRef = useRef(onResolved);
  onResolvedRef.current = onResolved;

  useEffect(() => {
    const missing = extractAssetIds(html).filter((id) => !requestedRef.current.has(id));
    if (!missing.length) return;
    missing.forEach((id) => requestedRef.current.add(id));
    getAssetUrls(missing).then((r) => {
      if (!r.success || !(r.data || []).length) return;
      (r.data || []).forEach((asset) => {
        if (asset && asset.url) urlsRef.current[asset.id] = asset.url;
      });
      if (onResolvedRef.current) onResolvedRef.current();
    });
  }, [html]);

  const toDisplay = useCallback(
    (value) => (value || "").replace(ASSET_MARKER_REGEX, (marker, id) => urlsRef.current[Number(id)] || marker),
    []
  );

  const fromDisplay = useCallback((value) => {
    let result = value || "";
    Object.keys(urlsRef.current).forEach((id) => {
      const url = urlsRef.current[id];
      if (!url) return;
      const marker = `mexx-email-asset://${id}`;
      // No atributo serializado o & da query vira &amp; — cobre as duas formas.
      result = result
        .replace(new RegExp(escapeRegExp(url.replace(/&/g, "&amp;")), "g"), marker)
        .replace(new RegExp(escapeRegExp(url), "g"), marker);
    });
    return result;
  }, []);

  return { toDisplay, fromDisplay };
}
